import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=0c808085&scoped=true&"
import script from "./subscribe.vue?vue&type=script&lang=js&"
export * from "./subscribe.vue?vue&type=script&lang=js&"
import style0 from "./subscribe.vue?vue&type=style&index=0&lang=css&"
import style1 from "./subscribe.vue?vue&type=style&index=1&id=0c808085&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c808085",
  null
  
)

export default component.exports